module.exports = __webpack_public_path__ + "img/children-dentristy-3.png";